import { __assign, __rest } from "tslib";
import React from 'react';
import CloseIcon from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';
import Tag from '../Tag';
var RemovableTag = function (_a) {
    var rest = __rest(_a, []);
    return React.createElement(Tag, __assign({ postfix: React.createElement(CloseIcon, { size: IconSize.TINY }) }, rest));
};
RemovableTag.displayName = 'RemovableTag';
export default RemovableTag;
//# sourceMappingURL=RemovableTag.js.map